module.exports = __webpack_public_path__ + "img/no-data.40da5ff8.png";